import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const AsyncPersonalization = loadable(() => pMinDelay(import('./AsyncPersonalizationTerms'), 300), {
  fallback: <Loading />
});

const AsyncPersonalizationTerms = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <AsyncPersonalization { ...props } />
    </ApplicationLayout>
  );
};

AsyncPersonalizationTerms.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncPersonalizationTerms;